import type { WeeklyPointSummaryConfig, WidgetConfig } from "@/lib/schema";
import { getWidgetModule } from "@/widgets/registry";
import type { WeekWidgetModule } from "@/widgets/types";
import { SettingsEditor } from "./SettingsEditor";
import { validate } from "./validate";
import { WeekView } from "./WeekView";

function defaults(existing: WidgetConfig[]): WeeklyPointSummaryConfig {
  const weekWidgets = existing.filter(
    (w) => getWidgetModule(w.kind)?.scope === "week",
  );
  const maxRow = weekWidgets.reduce((m, w) => Math.max(m, w.row), -1);
  return {
    id: crypto.randomUUID(),
    kind: "weekly-point-summary",
    label: "Ukentlig poengoversikt",
    row: maxRow + 1,
    column: 0,
    enabled: true,
    rows: [],
  };
}

export const weeklyPointSummary: WeekWidgetModule<WeeklyPointSummaryConfig> = {
  kind: "weekly-point-summary",
  label: "Ukentlig poengoversikt",
  scope: "week",
  scoring: "none",
  defaults,
  validate,
  SettingsEditor,
  WeekView,
};
